export default __webpack_public_path__ + "static/media/cara.595faeb5.png";